// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".style-module__iSetting___aCwQ7 {\n  margin-top: 10px;\n  margin-bottom: 30px;\n}\n", "",{"version":3,"sources":["webpack://./app/components/LookerSettings/style.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".iSetting {\n  margin-top: 10px;\n  margin-bottom: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iSetting": "style-module__iSetting___aCwQ7"
};
export default ___CSS_LOADER_EXPORT___;
